import React, { useState, useRef, useEffect } from "react";

const GuestRoomSelector = ({ 
  rooms, setRooms, 
  adults, setAdults, 
  children, setChildren, 
  extrabeds, setExtrabeds // <-- New props
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  return (
    <div className="position-relative" ref={dropdownRef}>
      <label className="form-label ">Add Guests & Rooms
      </label>

      <div
        className="form-control d-flex justify-content-between align-items-center"
        onClick={toggleDropdown}
        style={{ cursor: "pointer" }}
      >
        {adults + children} Guest{adults + children > 1 ? "s" : ""} | {rooms} Room{rooms > 1 ? "s" : ""} 
        {extrabeds > 0 && ` | ${extrabeds} Extra bed${extrabeds > 1 ? "s" : ""}`}
        <i className="bi bi-chevron-down"></i>
      </div>

      {dropdownOpen && (
        <div
          className="position-absolute bg-white shadow p-3 mt-2 rounded"
          style={{ zIndex: 999, width: "100%", minWidth: "280px" }}
        >
          {/* Rooms */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span>Rooms (Max 4)</span>
            <div>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setRooms(Math.max(1, rooms - 1))}
              >
                -
              </button>
              <span className="mx-2">{rooms}</span>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setRooms(Math.min(4, rooms + 1))}
              >
                +
              </button>
            </div>
          </div>

          {/* Adults */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span>Adults (17+ yr)</span>
            <div>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setAdults(Math.max(1, adults - 1))}
              >
                -
              </button>
              <span className="mx-2">{adults}</span>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setAdults(adults + 1)}
              >
                +
              </button>
            </div>
          </div>

          {/* Children */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span>Children (1–17 yr)</span>
            <div>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setChildren(Math.max(0, children - 1))}
              >
                -
              </button>
              <span className="mx-2">{children}</span>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setChildren(children + 1)}
              >
                +
              </button>
            </div>
          </div>

          {/* Extra Beds */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span>Extra Beds (Max 5)</span>
            <div>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setExtrabeds(Math.max(0, extrabeds - 1))}
              >
                -
              </button>
              <span className="mx-2">{extrabeds}</span>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setExtrabeds(Math.min(5, extrabeds + 1))}
              >
                +
              </button>
            </div>
          </div>

          {/* Tip */}
          <div className="bg-light p-2 rounded mb-3">
            <strong>Travelling with children?</strong>
            <p className="mb-0" style={{ fontSize: "0.85rem" }}>
              Add number of children and their age to get the best room options,
              prices, etc.
            </p>
          </div>

          {/* Done button */}
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-warning px-4 fw-bold"
              onClick={() => setDropdownOpen(false)}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GuestRoomSelector;
